import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import {
  Provider as FUIProvider
 } from '@fluentui/react-northstar';
import {getMicrosoftTeamsTheme} from '../utils/getMicrosoftTeamsTheme';

import { PageTitle } from '../components/PageTitle';

import styling from '../components/styling';


export function WelcomePage() {
  const [tr] = useTranslation();
  const cocoomState = useSelector(state => state.cocoom);
  const themeName = cocoomState.msteamsTheme;
  const msTeamsTheme = getMicrosoftTeamsTheme(themeName);

  return (
    <FUIProvider theme={msTeamsTheme} style={{background: 'transparent'}}>
      <div style={{textAlign: 'center'}}>
        <div style={{margin: styling.spacing(1), textAlign: 'left', maxWidth: 480, display: 'inline-block'}}>
          <PageTitle theme={themeName} styles={{textAlign: 'center'}} text={tr('welcomePage.title')} />
        </div>
      </div>
    </FUIProvider>
  );
}
